import "./ProductDetailsViewComponent.scss";
import ButtonComponent from "../../../../../shared/components/core/button/ButtonComponent";
import EditIcon from "@mui/icons-material/Edit";
import React from "react";
import {Grid} from "@mui/material";
import DetailsDataKeyValueComponent
    from "../../../../../shared/components/details-data-key-value-component/detailsDataKeyValueComponent";
import commonService from "../../../../../shared/services/common.service";
import AttachmentViewDownloadComponent
    from "../../../../../shared/components/core/attachment-view-download/attachmentViewDownloadComponent";

interface ProductDetailsViewComponentProps {
    productDetails: any;
    canEdit: boolean;
    onEditModeOpen: Function;

}

const ProductDetailsViewComponent = (props: ProductDetailsViewComponentProps) => {
    const {canEdit, onEditModeOpen, productDetails} = props;
    return (
        <div className={'product-details-view-component details-tab-data-content'}>
            <div className="details-tab-data-header">
                <div className="view-and-edit-title">Basic Information</div>
                <div className="">
                    {
                        canEdit &&
                        <ButtonComponent
                            className={"white-space-nowrap"}
                            type="button"
                            color={"primary"}
                            variant={"outlined"}
                            startIcon={<EditIcon/>}
                            fullWidth={true}
                            handleClick={onEditModeOpen}
                        >
                            Edit Details
                        </ButtonComponent>
                    }
                </div>
            </div>
            <div className="details-tab-data-body">
                <Grid container spacing={2} className="pdd-top-0">
                    <Grid item xs={12} sm={12} md={6} xl={6}>
                        <DetailsDataKeyValueComponent
                            title={"Product Name"}> {productDetails?.name || 'NA'} </DetailsDataKeyValueComponent>
                        <DetailsDataKeyValueComponent
                            title={"Product Code"}> {productDetails?.productCode || 'NA'} </DetailsDataKeyValueComponent>
                        <DetailsDataKeyValueComponent
                            title={"Alert Level Quantity"}> {productDetails?.alertLevelStock || 'NA'} </DetailsDataKeyValueComponent>

                    </Grid>
                    <Grid item xs={12} sm={12} md={6} xl={6}>
                        <DetailsDataKeyValueComponent
                            title={"Panel Name"}> {productDetails?.panelDetails?.name ? commonService.capitalizeFirstLetterOfEachWord(productDetails?.panelDetails?.name) : 'NA'} </DetailsDataKeyValueComponent>
                        <DetailsDataKeyValueComponent
                            title={"Quantity"}> {productDetails?.quantity || 'NA'} </DetailsDataKeyValueComponent>
                        <DetailsDataKeyValueComponent
                            title={"Retail Price"}>$ {productDetails?.price || 'NA'} </DetailsDataKeyValueComponent>
                    </Grid>
                </Grid>
                <DetailsDataKeyValueComponent
                    title={"Description"}> {productDetails?.description || 'NA'} </DetailsDataKeyValueComponent>
                <div className={'product-images-title'}>Product Images</div>
                <div className={'product-images-wrapper'}>
                    <div className={'product-images'}>
                        {
                            productDetails?.images?.map((image: any, index: number) => {
                                return (
                                    <div className={'product-image'} key={index}>
                                        <AttachmentViewDownloadComponent attachment={image} attachmentTitle={image?.fileName || "product_image"}/>
                                    </div>
                                )
                            })
                        }
                    </div>
                </div>
                <div className={'horizontal-line'}></div>
                <div className="view-and-edit-title">Additional Details</div>
                <DetailsDataKeyValueComponent
                    title={"Product Catalog Link"}> {productDetails?.productCatalogLink || 'NA'} </DetailsDataKeyValueComponent>

                <Grid container spacing={2} className="pdd-top-0">
                    <Grid item xs={12} sm={12} md={6} xl={6}>
                        <DetailsDataKeyValueComponent
                            title={"Product Tagline"}> {productDetails?.tagLine || 'NA'} </DetailsDataKeyValueComponent>
                        <DetailsDataKeyValueComponent
                            title={"Results Available In"}> {productDetails?.resultingDays ? (productDetails?.resultingDays + "days") : 'NA'} </DetailsDataKeyValueComponent>

                    </Grid>
                    <Grid item xs={12} sm={12} md={6} xl={6}>
                        <DetailsDataKeyValueComponent
                            title={"Collection Process"}> {productDetails?.methodOfCollection || 'NA'} </DetailsDataKeyValueComponent>
                        <DetailsDataKeyValueComponent
                            title={"Test Analytes"}>
                            {
                                productDetails?.analytes && productDetails?.analytes?.length > 0 ? productDetails?.analytes.join(', ') : 'NA'
                            }
                        </DetailsDataKeyValueComponent>
                    </Grid>
                </Grid>
            </div>
        </div>
    );

};

export default ProductDetailsViewComponent;
